// extracted by mini-css-extract-plugin
export default {"slide":"slide-image-ui_slide__5WsQ1","slide__image":"slide-image-ui_slide__image__PNRD0"};